/**
 * Attribution + PWA glue (growth). Runs before the game boots.
 * - Reads ?ref= / utm_* / source= from the landing URL, stores them once, and registers them as
 *   PostHog super properties so every event carries acquisition context (WhatsApp invites, Galaxy push).
 * - Registers the service worker for offline play / add-to-home-screen.
 */
import posthog from "posthog-js";

const KEY = "mozaik.attribution";

export interface Attribution {
  ref?: string;
  source?: string;
  medium?: string;
  campaign?: string;
  landedAt: number;
}

export function captureAttribution(): Attribution | null {
  let existing: Attribution | null = null;
  try {
    existing = JSON.parse(localStorage.getItem(KEY) ?? "null") as Attribution | null;
  } catch {
    /* ignore */
  }
  const q = new URLSearchParams(location.search);
  const fresh: Attribution = {
    ref: q.get("ref") ?? undefined,
    source: q.get("utm_source") ?? q.get("source") ?? undefined,
    medium: q.get("utm_medium") ?? undefined,
    campaign: q.get("utm_campaign") ?? undefined,
    landedAt: Date.now(),
  };
  const hasFresh = Boolean(fresh.ref || fresh.source || fresh.medium || fresh.campaign);
  // First touch wins (invite attribution must not be overwritten by a later organic open).
  const attr = existing ?? (hasFresh ? fresh : null);
  if (attr && !existing) {
    try {
      localStorage.setItem(KEY, JSON.stringify(attr));
    } catch {
      /* ignore */
    }
  }
  if (attr) {
    posthog.register({
      attr_ref: attr.ref ?? "",
      attr_source: attr.source ?? "",
      attr_medium: attr.medium ?? "",
      attr_campaign: attr.campaign ?? "",
    });
  }
  // Clean the URL so the ref isn't re-shared accidentally.
  if (hasFresh && history.replaceState) history.replaceState(null, "", location.pathname);
  return attr;
}
